import React, { useEffect, useState } from "react";
import Pagination from "../components/common/Pagination";
import Loader from "../components/common/Loader";
import useAxios from "../utils/useAxios";

const formatDate = (dateValue) => {
  if (!dateValue || dateValue === "0000-00-00") {
    return "-";
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const PendingDonation = () => {
  const axiosAPI = useAxios();
  const [loading, setLoading] = useState(true);
  const [pendingDonors, setPendingDonors] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchPendingDonors = async (currentPage) => {
    setLoading(true);

    try {
      const response = await axiosAPI.get(
        `/api/pending-donor/pending-regular-donors?page=${currentPage}`,
      );

      setPendingDonors(response?.data?.data || []);
      setTotalPages(response?.data?.totalPages || 1);
      setTotalRecords(response?.data?.total || 0);
    } catch (error) {
      console.error("Error fetching pending donors:", error);
      setPendingDonors([]);
      setTotalPages(1);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingDonors(page);
  }, [page]);

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
  };

  return (
    <div className="container">
      <div className="page-inner">
        {loading && <Loader />}

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h4 className="card-title mb-0">
                  Pending Donations ({totalRecords})
                </h4>
                <span className="text-muted">Page {page} of {totalPages}</span>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped align-middle">
                    <thead>
                      <tr>
                        <th>Sr no.</th>
                        <th>Donor ID</th>
                        <th>Full Name</th>
                        <th>Phone Number</th>
                        <th>Email</th>
                        <th>Monthly Amount</th>
                        <th>Status</th>
                        <th>Start Date</th>
                        <th>Pending Months</th>
                        <th>Pending Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading && pendingDonors.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No pending donors found
                          </td>
                        </tr>
                      ) : (
                        pendingDonors.map((donor, index) => (
                          <tr key={donor.id}>
                            <td>{(page - 1) * 100 + index + 1}</td>
                            <td>{donor.donor_id || "-"}</td>
                            <td>{donor.full_name || "-"}</td>
                            <td>{donor.phone_number || "-"}</td>
                            <td>{donor.email || "-"}</td>
                            <td>{donor.monthly_amount || "-"}</td>
                            <td>
                              <span className="badge badge-success text-uppercase">
                                {donor.status || "-"}
                              </span>
                            </td>
                            <td>{formatDate(donor.start_date)}</td>
                            <td>
                              {donor.pending_months?.length ? (
                                donor.pending_months.map((item) => (
                                  <div key={`${donor.id}-${item.month}`} className="mb-1">
                                    <strong>{item.month}</strong> - {item.status}
                                    <div className="small text-muted">
                                      Grace ends: {formatDate(item.grace_ends_on)}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{donor.pending_count ?? 0}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination
              page={page}
              totalPages={totalPages}
              handlePageClick={handlePageClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingDonation;